import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import sanitizeHtml from 'sanitize-html';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  richtext: {
    fontSize: theme.typography.fontSize,
    fontFamily: theme.typography.fontFamily,
  },
}));

const RichText = ({
  className = null,
  content = '',
  ...props
}) => {
  const classes = useStyles();
  return (
    <div
      className={clsx(classes.richtext, className)}
      dangerouslySetInnerHTML={{ // eslint-disable-line
        __html: sanitizeHtml(content, {
          allowedTags: sanitizeHtml.defaults.allowedTags.concat(['u', 'h1', 'h2', 'span', 'br', 'sup', 'sub', 'ins', 'del']),
          allowedAttributes: {
            '*': ['style'],
            ...sanitizeHtml.defaults.allowedAttributes,
          },
          allowedStyles: {
            '*': {
              // Match HEX and RGB
              color: [/^#(0x)?[0-9a-f]+$/i, /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/],
              'background-color': [/^#(0x)?[0-9a-f]+$/i, /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/],
              'text-align': [/^left$/, /^right$/, /^center$/, /^justify$/],
              // Match any number with px, em, or %
              'font-size': [/^\d+(?:px|em|%)$/],
              'font-faimly': [/^.*$/],
            },
          },
          // transformTags: {
          //   '*': function (tagName, attribs) {
          //     console.log(tagName, attribs.style);
          //     return {
          //       tagName: tagName,
          //       attribs: attribs
          //     };
          //   }
          // }
        }),
      }}
      {...props}
    />
  );
};
RichText.propTypes = {
  content: PropTypes.string,
  className: PropTypes.string,
};

export default RichText;
